/**
 * Registers the PWA service worker and sets up update detection.
 * Shared by both employee portal and admin portal (same domain, same SW).
 * Call this from each portal's entry point.
 */
import { setPwaUpdateAvailable } from './composables/usePwaUpdate';

export function registerPwaUpdates(): void {
    if (!('serviceWorker' in navigator)) return;

    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/sw.js', { scope: '/' })
            .then((registration) => {
                registration.addEventListener('updatefound', () => {
                    const newWorker = registration.installing;
                    if (!newWorker) return;
                    newWorker.addEventListener('statechange', () => {
                        if (newWorker.state === 'installed' && registration.waiting) {
                            setPwaUpdateAvailable(registration);
                        }
                    });
                });
                if (registration.waiting) {
                    setPwaUpdateAvailable(registration);
                }
                navigator.serviceWorker.addEventListener('controllerchange', () => {
                    window.location.reload();
                });
            })
            .catch((err) => console.warn('SW registration failed:', err));
    });
}
